import TrackingPermissions from '../../../../../permissions';

import { usePermissions } from '@cobliteam/hooks';
import Button from '@cobliteam/ui/components/Button';
import Dropdown from '@cobliteam/ui/components/Dropdown';
import Icon from '@cobliteam/ui/icons';
import MapLegendOverlay from './MapLegendOverlay';
import { type LegendItem, baseLegendItems, itemsWhenAllowedToViewPlacesOfInterest, itemsWhenNotAllowedToViewPlacesOfInterest, mediaEventItems } from './items';

interface MapLegendProps {
  showMediaEvents: boolean;
}

export const MapLegend = ({ showMediaEvents }: MapLegendProps) => {
  const { isAccessAllowed } = usePermissions();
  const isAllowedToViewPlacesOfInterest = isAccessAllowed(TrackingPermissions.VIEW_PLACES_OF_INTEREST);

  const legendItems: LegendItem[] = [
    ...baseLegendItems,
    ...(isAllowedToViewPlacesOfInterest ? itemsWhenAllowedToViewPlacesOfInterest : itemsWhenNotAllowedToViewPlacesOfInterest),
    ...(showMediaEvents ? mediaEventItems : []),
  ];

  return (
    <Dropdown overlay={<MapLegendOverlay legendItems={legendItems} />}>
      <Button variant='outlined' startIcon={<Icon name='captions' />} className='bg-white shadow hover:bg-gray-4'>
        Legenda
      </Button>
    </Dropdown>
  );
};

export default MapLegend;
